import { createSelector } from '@reduxjs/toolkit';
import lodashPick from 'lodash/pick';

import constants from '../../Config/constants';

const shop = (state) => state.shop;
const EMPTY_ARRAY = [];

const shopFeaturedItemsSelector = createSelector(
  shop,
  (state) => state.data.featured_items,
);
const shopLoadingSelector = createSelector(shop, (state) => state.loading);
const shopRawSelector = createSelector(shop, (state) => state.rawData);
const shopSelector = createSelector(shop, (state) => state.data);
const shopOrderTypeKeysSelector = createSelector(shop, (state) =>
  lodashPick(state.data, constants.ORDER_TYPE_API_KEYS),
);
const shopMenuSelector = createSelector(
  shopSelector,
  (shopData) => shopData?.menu_list || EMPTY_ARRAY,
);
const selectRefetchMenu = createSelector(shop, (state) => state.refetchMenu);

export {
  shopFeaturedItemsSelector,
  shopLoadingSelector,
  shopRawSelector,
  shopSelector,
  shopOrderTypeKeysSelector,
  shopMenuSelector,
  selectRefetchMenu,
};
